// import { getBranchListBySelectedService, getSortedPriorityList, isServiceForAge, sortListByName } from './utils';
import { createSelector } from 'reselect';
import { FILTER_BY_PROFILE, FILTER_BY_CONTROL } from './serviceSlice';
import {
    getServiceList, isServiceForAge, isServiceForProfile, sortListByName,
} from '../util/service';
import { formatFullDate, sortBy } from '../../utils';
import { getActualTimeslotsObj, getTimeslotsForCurrentDate, isFutureTimeslot } from '../util/timeSlots';

export const Self = state => state;
export const Services = createSelector([Self], state => state?.services);

// export const selectorService = createSelector([Services], services => ({
//     filter: {
//         ...services.filter,
//         branches: getBranchListBySelectedService(services),
//     },
//     error: services.error,
//     branches: services.branches,
//     branchesMetadata: [],
//     directions: services.directions,
//     districts: services.districts,
//     services: services.services,
//     selected: services.selected,
//     data: services.data,
//     selectedData: services.selectedData,
//     isBranchesLoading: services.isBranchesLoading,
//     isBranchesVisible: services.isBranchesVisible,
//     isLoading: services.isLoading,
//     selectedProfile: services?.selectedProfile,
// }));

export const getServiceFilter = createSelector([Services], (services) => {
    return services?.filter;
});

export const getCitizenshipId = createSelector([Services], services => services?.citizenshipId ?? 'belarus');

export const getServiceOptions = createSelector([ getServiceFilter, getCitizenshipId ], (filter, citizenshipId) => {
    const services = filter?.services ?? [];
    return citizenshipId === 'foreign'
        ? services.map(service => ({ ...service, price: service.internationalPrice }))
        : services;
});

export const getHasInternationalPriceInCatalog = createSelector([Services], (services) => {
    const serviceData = services?.servicesData ?? [];
    return serviceData.some(({ subGroups = [] }) => subGroups.some(({ services: serviceList = [] }) => (
        serviceList.some(service => service?.internationalPrice != null)
    )));
});

export const getHasChildServices = createSelector([Services], (services) => {
    const childServiceIds = new Set((services?.servicesData ?? []).flatMap(({ subGroups = [] }) => (
        subGroups.flatMap(({ services: serviceList = [] }) => serviceList
            .filter(service => service.forChildren === true && service.id != null)
            .map(service => service.id))
    )));
    return (services?.doctors ?? []).some(doctor => doctor.children === true && doctor.worksAt?.some(
        ({ serviceMappings = [] }) => serviceMappings.some(({ serviceId }) => childServiceIds.has(serviceId)),
    ));
});

export const getServiceSelected = createSelector([Services], services => ({
    ...services?.selected,
    timeslot: services?.activeTimeslotId,
}));

// export const getServiceBranches = createSelector([Services], services => ({ branches: services?.branchesData }));

// export const getServicePriority = createSelector([Services], (services) => {
//     const priority = services?.filter?.priority ?? {};
//     return getSortedPriorityList(priority);
// });
//
export const getChildrenState = createSelector([Services], (services) => {
    const {
        forChild,
        childrenAge,
    } = services;
    return {
        forChild,
        childrenAge,
    };
});

export const getServiceBookingError = createSelector([Services], services => services?.bookingError);

export const getSelectedService = createSelector([Services], (services) => {
    const serviceId = services.selected?.services;
    const selectedServices = services.filter.services?.find(e => e.id === serviceId);
    return {
        selected: services.selected,
        isLoading: services.isLoading,
        isDataLoaded: !services.isServicesLoading && !services.isDoctorsLoading && !services.isBranchesLoading, // && !services.isLoading
        selectedProfile: services.selectedProfile,
        branch: services.selected?.branches,
        serviceId,
        serviceName: selectedServices?.name,
        selectedServices,
    };
});

export const getServicesInfoLoaded = createSelector([Services], (services) => {
    return !services.isServicesLoading && !services.isDoctorsLoading && !services.isBranchesLoading;
});

// export const getSelectedServiceId = createSelector([Services], services => services.selected?.services);

export const getSelectedBranch = createSelector([Services], services => services?.selected?.branches);
export const getBranches = createSelector([Services], services => services?.branches);

export const getBranchesData = createSelector([Services], services => services?.branchesData);

export const getSelectedBranchesData = createSelector([ getSelectedBranch, getBranchesData ], (id, data = []) => {
    return data?.find(({ branchId }) => id === branchId);
});

export const getSelectedBranchObject = createSelector([ Services, getSelectedBranch, getBranches ], (services, selectedBranch, branches) => {
    return branches?.find(({ id }) => id === selectedBranch);
});
export const getSelectedDoctor = createSelector([Services], services => services?.selected?.doctors);

// export const getSelectedProfile = createSelector([Services], services => services?.selectedProfile);

export const getDoctors = createSelector([Services], services => services?.doctors ?? []);
export const getDoctorListObject = createSelector([getDoctors], doc => doc?.reduce?.(
    (prev, { doctorId, ...rest }) => ({
        ...prev,
        [doctorId]: rest,
    }),
    {},
));

// export const getDoctorsBySelectedBranch = createSelector([Services], (services) => {
//     // const { services } = state;
//     const branchId = services.selected.branches;
//     if (!branchId) {
//         return [];
//     }
//     return services?.doctors
//         ?.filter(({ branches }) => branches?.includes(branchId))
//         .map(doctor => ({
//             ...doctor,
//             id: doctor?.doctorId,
//             name: doctor?.fullName,
//         }))
//         .sort(sortListByName);
// });
//
export const getDoctorsBySelectedBranchAndService = createSelector([Services], (services) => {
    const branchId = services.selected.branches;
    const id = services.selected.services;
    const age = services?.childrenAge ?? -1;
    if (!branchId) {
        return [];
    }
    return services?.doctors
        ?.filter(
            ({
                branches,
                children: forChildren,
                adult: forAdult,
                children_age: childrenAge,
                children_age_to: childrenAgeTo,
            }) => (!(FILTER_BY_PROFILE || FILTER_BY_CONTROL) ||
                    isServiceForProfile({
                        age,
                        serviceForAdult: forAdult,
                        serviceForChild: forChildren,
                        serviceAge: childrenAge,
                        serviceAgeTo: childrenAgeTo,
                        child: services?.forChild,
                    })) &&
                branches?.includes(branchId),
        )
        .map(doctor => ({
            ...doctor,
            id: doctor?.doctorId,
            name: doctor?.fullName,
            serviceMappings: doctor?.worksAt?.find(({ branchId: _id }) => _id === branchId).serviceMappings,
        }))
        .filter(({ serviceMappings }) => serviceMappings?.find(({ serviceId }) => serviceId === id))
        .sort(sortListByName);
});

const getDoctorsPureMetadata = createSelector([Services], (services) => {
    return services?.doctors;
});

export const getDoctorsMetadata = createSelector([getDoctorsPureMetadata], (doctors) => {
    return doctors
        .map(doctor => ({
            ...doctor,
            id: doctor?.doctorId,
            name: doctor?.fullName,
            worksAt: doctor?.worksAt,
        }))
        .sort(sortListByName);
});

// export const getDeclineReasons = createSelector([Services], services => services?.declineReasons);
//
// export const getAgeRestrictions = createSelector([Services], (services) => {
//     return {
//         forChild: services?.forChild ?? false,
//         childrenAge: services?.childrenAge ?? -1,
//     };
// });
//
export const getSelected = createSelector([Services], services => services?.selected);

export const getSelectedDate = createSelector([Services], services => services?.date);

// export const selectorServiceTimetable = createSelector([Services], services => ({
//     error: services?.error,
//     isLoading: services?.isLoading,
//     doctorsMetadata: services?.doctors,
//     selectedDoctorId: services?.selected?.doctors,
//     date: services?.date,
//     richTimetable: services?.richTimetable?.[services?.selected?.doctors],
// }));
//
export const getSelectedDoctorObject = createSelector([ Services, getSelectedDoctor, getDoctors ], (services, selectedDoctorId, doctors) => doctors?.find?.(({ doctorId }) => doctorId === selectedDoctorId));

export const getTimetable = createSelector([ Services, getSelectedDoctorObject ], (services, doctor) => {
    const { assignment } = services;
    const serviceId = services?.selected?.services;
    const mappings = doctor?.worksAt?.find(({ assignmentId }) => assignmentId === assignment)?.serviceMappings ?? [];
    const slotDuration = mappings?.find(e => e.serviceId === serviceId)?.duration;
    const richTimetable = services?.richTimetable ?? [];
    const actualTimetable = getActualTimeslotsObj(richTimetable?.[doctor?.doctorId], slotDuration);
    // const actualTimetable = getActualTimeslotsObj(richTimetable?.[selectedDoctorId], slotDuration);
    let allData = [];
    if (actualTimetable?.freeTimeslots) {
        allData = Array.from(new Set([...actualTimetable.freeTimeslots.map(item => formatFullDate(item?.startTime))]));
    }
    return allData;
});

export const getTimetableForCurrentDoctor = createSelector([ Services, getSelectedDoctor, getSelectedDate ], (services, doctorId, date) => {
    const timetable = services?.richTimetable;
    // const doctorId = state.services?.selected?.doctors;
    // const date = state?.services?.date;
    return getTimeslotsForCurrentDate(
        timetable?.[doctorId]?.filter(e => isFutureTimeslot(e.startTime)),
        date,
    );
});

export const getTimeslots = createSelector([ Services, getSelectedDoctor ], (services, selectedDoctor) => {
    // const { services } = state;

    // const selectedDoctor = services?.selected?.doctors;
    const timeslots = services?.timeslots?.data ?? [];
    const child = services?.forChild;
    const age = services?.childrenAge ?? -1;
    const forProfile = timeslots?.filter(({
        adult: forAdult,
        children: forChildren,
        children_age: childrenAge = 0,
        children_age_to: childrenAgeTo,
    }) => (!(FILTER_BY_PROFILE || FILTER_BY_CONTROL) || isServiceForProfile({
        age,
        serviceAge: childrenAge,
        serviceAgeTo: childrenAgeTo,
        serviceForChild: forChildren,
        serviceForAdult: forAdult,
        child,
    })));
    const filterByDoctor = selectedDoctor ? forProfile?.filter?.(({ doctorId }) => doctorId === selectedDoctor) : forProfile;
    const arr = filterByDoctor?.filter(e => e?.nearestTimeslot);
    return [
        ...sortBy(arr, e => e?.freeTimeslots[0]?.startTime ?? e?.nearestTimeslot),
        ...filterByDoctor.filter(e => !e.nearestTimeslot),
    ];
});

export const getActiveTimeslotId = createSelector([Services], services => services?.activeTimeslotId);

export const getServiceDoctorPhotos = createSelector([Services], services => services?.photos ?? {});

export const getSelectedDoctorAssignment = createSelector([ Services, getDoctors, getSelectedDoctor, getSelectedBranch ], (services, doctors, selectedDoctorId, selectedBranchId) => {
    // const { services } = state;
    // const doctors = services?.doctors ?? [];
    // const selectedDoctorId = services?.selected?.doctors;
    // const selectedBranchId = services?.selected?.branches;
    const doctor = doctors?.find(({ doctorId }) => doctorId === selectedDoctorId);
    const assignmentObj = doctor?.worksAt?.find(({ branchId }) => branchId === selectedBranchId);
    return assignmentObj?.assignmentId;
});

export const getSelectedDoctorName = createSelector([getSelectedDoctorObject], doctor => doctor?.fullName ?? '');

export const getSelectedDoctorSpecialization = createSelector([ Services, getSelectedDoctorObject ], (services, doctor) => {
    return doctor?.specialityName ?? '';
});

export const getSelectedBranchName = createSelector([getSelectedBranchObject], (branch) => {
    return branch?.name ?? '';
});

export const getSelectedBranchDeeplink = createSelector([Services], (services) => {
    const branches = services?.branchesData ?? [];
    const selectedBranchId = services?.selected?.branches;
    const branch = branches?.find(({ branchId }) => branchId === selectedBranchId);
    return branch?.deepLink ?? '';
});

export const isDoctorAutoSelect = createSelector([Services], (services) => {
    return !!services?.doctorAutoSelect;
});

export const isBranchAutoSelect = createSelector([Services], (services) => {
    return !!services?.branchAutoSelect;
});

export const getSelectedDoctorAgeLimits = createSelector([Services], (services) => {
    // const { services } = state;
    const doctors = services?.doctors ?? [];
    const selectedDoctorId = services?.selected?.doctors;
    const doctor = doctors?.find(({ doctorId }) => doctorId === selectedDoctorId);
    const selectedService = services?.filter?.services?.find(({ id }) => services?.selected?.services === id);
    return {
        childrenAgeTo: doctor?.children_age_to || selectedService?.childrenAgeTo,
        adultAgeTo: doctor?.adult_age_to || selectedService?.adultAgeTo || 999,
        adultAge: doctor?.adult_age || selectedService?.adultAge || 18,
        childrenAge: (doctor?.children_age > selectedService?.childrenAge ? doctor?.children_age : selectedService?.childrenAge) || -1,
        adult: doctor?.adult && selectedService?.forAdult,
        children: doctor?.children && selectedService?.forChildren,
    };
});

export const getPreselectedData = createSelector([Services], services => services?.preselectedData);

export const getServiceFilterServices = createSelector([Services], (services) => {
    return services?.filter?.services ?? [];
});

export const getSpecialtyFilterDirections = createSelector([Services], (services) => {
    return services?.filter?.
        directions ??
     [];
});

export const getFullServicesFromServicesData = createSelector([Services], (services) => {
    return getServiceList(services?.servicesData ?? [], true);
});
